/* eslint-disable */

// This is a generated file and SHOULD NOT BE EDITED MANUALLY!!
// Contents are generated as part of grunt build
// Source of truth is lib/cdo/shared_constants.rb and files in lib/cdo/shared_constants/

export const Courses = [
  "CS Fundamentals",
  "CS Principles",
  "CS Discoveries",
  "Computer Science A",
  "Facilitator",
  "Admin/Counselor Workshop",
  "Exploring Computer Science",
  "CS in Algebra",
  "CS in Science",
  "Counselor",
  "Admin"
];

export const ActiveCourses = [
  "CS Fundamentals",
  "CS Principles",
  "CS Discoveries",
  "Computer Science A",
  "Facilitator",
  "Admin/Counselor Workshop"
];

export const ArchivedCourses = [
  "Exploring Computer Science",
  "CS in Algebra",
  "CS in Science",
  "Counselor",
  "Admin"
];

export const CourseKeyMap = {
  "CS Fundamentals": "csf",
  "CS Discoveries": "csd",
  "CS Principles": "csp",
  "Computer Science A": "csa"
};

export const SubjectNames = {
  "SUBJECT_CSF_101": "Intro",
  "SUBJECT_CSF_201": "Deep Dive",
  "SUBJECT_CSF_DISTRICT": "District",
  "SUBJECT_FIT": "Code.org Facilitator Weekend",
  "SUBJECT_SUMMER_WORKSHOP": "5-day Summer",
  "SUBJECT_VIRTUAL_KICKOFF": "Virtual Workshop Kickoff",
  "SUBJECT_CSP_FOR_RETURNING_TEACHERS": "Workshop for Returning Teachers",
  "SUBJECT_ADMIN_COUNSELOR_WELCOME": "Welcome",
  "SUBJECT_ADMIN_COUNSELOR_SLP_INTRO": "SLP Intro",
  "SUBJECT_ADMIN_COUNSELOR_SLP_CALL1": "SLP Quarterly Call 1",
  "SUBJECT_ADMIN_COUNSELOR_SLP_CALL2": "SLP Quarterly Call 2",
  "SUBJECT_ADMIN_COUNSELOR_SLP_CALL3": "SLP Quarterly Call 3",
  "SUBJECT_ADMIN_COUNSELOR_SLP_CALL4": "SLP Quarterly Call 4"
};

export const Subjects = {
  "Exploring Computer Science": [
    "Phase 2 in-person",
    "Unit 3 - HTML",
    "Unit 4 - Scratch",
    "Unit 5 - Data",
    "Unit 6 - Robotics",
    "Phase 4: Summer wrap-up"
  ],
  "CS in Algebra": [
    "Phase 2 in-person",
    "Phase 3: Academic Year Development"
  ],
  "CS in Science": [
    "Phase 2: Blended Summer Study",
    "Phase 3 - Semester 1",
    "Phase 3 - Semester 2"
  ],
  "CS Principles": [
    "5-day Summer",
    "Virtual Workshop Kickoff",
    "Academic Year Workshop 1",
    "Academic Year Workshop 2",
    "Academic Year Workshop 3",
    "Academic Year Workshop 4",
    "Academic Year Workshop 1 + 2",
    "Academic Year Workshop 3 + 4",
    "Code.org TeacherCon",
    "Code.org Facilitator Weekend",
    "Workshop for Returning Teachers"
  ],
  "Computer Science A": [
    "5-day Summer",
    "Virtual Workshop Kickoff",
    "Academic Year Workshop 1",
    "Academic Year Workshop 2",
    "Academic Year Workshop 3",
    "Academic Year Workshop 4",
    "Academic Year Workshop 1 + 2",
    "Academic Year Workshop 3 + 4",
    "Code.org Facilitator Weekend"
  ],
  "CS Discoveries": [
    "5-day Summer",
    "Virtual Workshop Kickoff",
    "Academic Year Workshop 1",
    "Academic Year Workshop 2",
    "Academic Year Workshop 3",
    "Academic Year Workshop 4",
    "Academic Year Workshop 1 + 2",
    "Academic Year Workshop 3 + 4",
    "Code.org TeacherCon",
    "Code.org Facilitator Weekend"
  ],
  "CS Fundamentals": [
    "Intro",
    "Deep Dive",
    "District",
    "Code.org Facilitator Weekend"
  ],
  "Admin/Counselor Workshop": [
    "Welcome",
    "SLP Intro",
    "SLP Quarterly Call 1",
    "SLP Quarterly Call 2",
    "SLP Quarterly Call 3",
    "SLP Quarterly Call 4"
  ]
};

export const VirtualOnlySubjects = [
  "Virtual Workshop Kickoff"
];

export const HideFeeInformationSubjects = [
  "District"
];

export const HideOnWorkshopMapSubjects = [
  "District"
];

export const HideFundedSubjects = [
  "District"
];

export const MustSuppressEmailSubjects = [
  "Code.org TeacherCon",
  "Code.org Facilitator Weekend",
  "Code.org TeacherCon",
  "Code.org Facilitator Weekend",
  "Code.org Facilitator Weekend",
  "Welcome",
  "SLP Intro",
  "SLP Quarterly Call 1",
  "SLP Quarterly Call 2",
  "SLP Quarterly Call 3",
  "SLP Quarterly Call 4"
];

export const AcademicYearWorkshopSubjects = [
  "Virtual Workshop Kickoff",
  "Academic Year Workshop 1",
  "Academic Year Workshop 2",
  "Academic Year Workshop 3",
  "Academic Year Workshop 4",
  "Academic Year Workshop 1 + 2",
  "Academic Year Workshop 3 + 4"
];

export const LegacySubjects = {
  "CS Principles": [
    "Workshop 1: Unit 3",
    "Workshop 2: Unit 4 and Explore Task",
    "Workshop 3: Unit 5 and Create Task",
    "Workshop 4: Unit 5 and Multiple Choice Exam",
    "2-day, Workshops 1+2: Units 3-4 and Explore Task",
    "2-day, Workshops 3+4: Unit 5, Create Task, and Multiple Choice Exam",
    "1-day Academic Year, Units 1 and 2",
    "1-day Academic Year, Unit 3",
    "1-day Academic Year, Unit 4 + Explore Prep",
    "1-day Academic Year, Unit 5 + Create Prep",
    "2-day Academic Year, Units 1 to 3",
    "2-day Academic Year, Units 4 and 5 + AP Prep",
    "Virtual Workshop 1",
    "Virtual Workshop 2",
    "Virtual Workshop 3",
    "Virtual Workshop 4",
    "Virtual Workshop 5",
    "Virtual Workshop 6",
    "Virtual Workshop 7",
    "Virtual Workshop 8"
  ],
  "CS Discoveries": [
    "Workshop 1: Unit 3",
    "Workshop 2: Unit 4",
    "Workshop 3: Unit 5",
    "Workshop 4: Unit 6",
    "2-day, Workshops 1+2: Units 3 and 4",
    "2-day, Workshops 3+4: Units 5 and 6",
    "1-day Academic Year, Units 1 and 2",
    "1-day Academic Year, Unit 3",
    "1-day Academic Year, Units 4 and 5",
    "1-day Academic Year, Unit 6",
    "2-day Academic Year, Units 1 to 3",
    "2-day Academic Year, Units 4 to 6",
    "Virtual Workshop 1",
    "Virtual Workshop 2",
    "Virtual Workshop 3",
    "Virtual Workshop 4",
    "Virtual Workshop 5",
    "Virtual Workshop 6",
    "Virtual Workshop 7",
    "Virtual Workshop 8"
  ]
};

export const States = [
  "Not Started",
  "In Progress",
  "Ended"
];

export const WorkshopApplicationStates = {
  "now_closed": "now_closed",
  "currently_open": "currently_open",
  "opening_at": "opening_at",
  "opening_sometime": "opening_sometime"
};

export const WorkshopSearchErrors = {
  "no_partner": "no_partner",
  "no_state": "no_state",
  "unknown": "unknown"
};

export const ActiveCourseWorkshops = {
  "CSD": "CS Discoveries",
  "CSP": "CS Principles",
  "CSA": "Computer Science A"
};

export const ActiveCoursesWithSurveys = [
  "CS Discoveries",
  "CS Principles",
  "Computer Science A",
  "CS Fundamentals"
];

export const WorkshopTypes = {
  "teachercon": "Code.org TeacherCon",
  "local_summer": "5-day Summer",
  "both": "both"
};

export const NotFundedSubjects = [
  "Welcome",
  "SLP Intro",
  "SLP Quarterly Call 1",
  "SLP Quarterly Call 2",
  "SLP Quarterly Call 3",
  "SLP Quarterly Call 4"
];
